import { getLogInRoute, getRegisterRoute } from '@shared';
import NextLink from 'next/link';
import styled from 'styled-components';

const Anchor = styled.a`
  color: ${(props) => props.theme.grey.string()};
  text-decoration: none;
  transition: color 300ms;
  span {
    font-weight: ${(props) => props.theme.fontWeightBold};
  }

  &:active,
  &:hover {
    color: ${(props) => props.theme.navy.string()};
  }
`;

const Wrapper = styled.div`
  margin: 1.5rem auto 1rem;

  span {
    margin: auto 0.4rem;
  }
`;

interface SignUpSignInTextProps {
  hasAccount: boolean;
  redirectTo: string;
}

export function SignUpSignInText({
  hasAccount,
  redirectTo,
}: SignUpSignInTextProps) {
  const action = hasAccount ? 'Sign in' : 'Sign up';

  const href = hasAccount
    ? getLogInRoute(redirectTo)
    : getRegisterRoute(redirectTo);

  const text = hasAccount
    ? 'Already have an account?'
    : "Don't have an account yet?";

  return (
    <Wrapper>
      <NextLink href={href} passHref legacyBehavior>
        <Anchor>
          {text}
          <span>{action}</span>
        </Anchor>
      </NextLink>
    </Wrapper>
  );
}
